import React from "react";

const HeatmapTable = ({ stats, factor, unit }) => {
  if (!stats || typeof stats !== "object") return null;

  const hours = Object.keys(stats);
  if (!hours.length) return null;

  const metrics = [
    { key: "max", label: "Máx" },
    { key: "min", label: "Mín" },
    { key: "avg", label: "Media" },
    { key: "median", label: "Mediana" },
    { key: "stddev", label: "Desv. Est." },
  ];

  return (
    <div className="heatmap-table-wrapper-vertical">
      <table className="heatmap-table-vertical">
        <thead>
          <tr>
            <th>Hora</th>
            {metrics.map((m) => (
              <th key={m.key}>{m.label} ({unit})</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {hours.map((h) => (
            <tr key={h}>
              <td className="sticky-hour">
                {h.length >= 5 ? h.slice(0, 5) : h}
              </td>
              {metrics.map((metric) => (
                <td key={metric.key}>
                  {stats[h][metric.key] != null
                    ? (stats[h][metric.key] / factor).toFixed(2)
                    : "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HeatmapTable;